module.exports = {
	"articleTitle1": "Gallery: Michigan and Florida players attend the Buffalo Wild Wings ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Buffalo Wild Wings",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/sports/notebook-morris-not-gardner-likely-start-buffalo-wild-wings-bowl",
	"articleSnippet1": "Dec 30, 2015 ... Players joined kids from the Boys & Girls Clubs of Central Florida outside the \nCitrus Bowl on Wednesday.",
	"articleSnippet2": "Dec 23, 2013 ... If the Buffalo Wild Wings Bowl was played today instead of Saturday night, \nfreshman quarterback Shane Morris would be the starter in place of ...",
	"foodRecommendations": [
		{
			"text": "Never really has the best service, but that BDubs for you. The wings, as most people already know, are really good.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Notebook: Morris, not Gardner, likely to start Buffalo Wild Wings Bowl",
	"address": "205 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.28008,
		"lng": -83.740511
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/buffalowildwings.json
// module id = 837
// module chunks = 0